module.exports = __webpack_public_path__ + "img/clock-four-thirty.689f9ca4.svg";